module.exports = __webpack_public_path__ + "img/casitaMobile.cedd17a7.svg";